import { connect } from 'react-redux';
import SupportArticles from '../../components/Support/SupportArticles';
import SupportAction from '../actions/SupportAction';
import { supportSelector } from '../reducers/SupportReducer';

const mapStateToProps = (state, ownProps) => {
  const categoryId = ownProps.routeParams.categoryId;
  const category = supportSelector.getCategory(categoryId, state);

  return {
    category,
    categoryId,
    selectedArticle: ownProps.routeParams.articleId,
    path: ownProps.location.pathname
  };
};

const mapDispatchToPropsFactory = (dispatch) => {
  const fetchArticles = id => dispatch(SupportAction.fetchArticles(id));
  const fetchSubArticles = id => dispatch(SupportAction.fetchSubArticles(id));
  return { fetchArticles, fetchSubArticles };
};

const mergeProps = (stateProps, dispatchProps) => ({
  title: stateProps.category.title,
  articles: stateProps.category.articles,
  articlesPending: stateProps.category.articlesPending,
  selectedArticle: stateProps.selectedArticle,
  path: stateProps.path,
  fetchArticles: () => dispatchProps.fetchArticles(stateProps.categoryId),
  fetchSubArticles: () => dispatchProps.fetchSubArticles(stateProps.categoryId)
});

export default connect(mapStateToProps, mapDispatchToPropsFactory, mergeProps)(SupportArticles);



/** WEBPACK FOOTER **
 ** ./src/redux/containers/SupportArticlesContainer.js
 **/